// extracted by mini-css-extract-plugin
export default {"answerLabel":"S_c4","success":"S_c5"};